// extracted by mini-css-extract-plugin
module.exports = {"projectdiv":"InspectionTrendProjectList_projectdiv__mwP_8","head":"InspectionTrendProjectList_head__2wgaz"};